import script from "./FormPlanesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPlanesComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormPlanesComponent.vue?vue&type=style&index=0&id=85ad8bb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85ad8bb2"]])

export default __exports__